import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router"
import { Button } from "@cividao/components"
import styles from "./index.module.css"

export function ErrorTemplate() {
  const { t } = useTranslation("error")
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t("title")}</h1>
      <p className={styles.message}>{t("notFound")}</p>
      <Button onClick={() => navigate("/")}>{t("goBack")}</Button>
    </div>
  )
}
